import { phoneMask } from "../utils/mask";

function floatingFormControl() {
    const floatingFormToggle = document.getElementById('floating-form-toggle');
    const floatingFormIcon = document.getElementById('floating-form-icon');
    const floatingForm = document.getElementById('floating-form');
    const phoneInput = document.getElementById('phone');

    if (!floatingForm || !floatingFormIcon || !floatingFormToggle) return;

    if (phoneInput) {
        phoneMask(phoneInput);
    }

    function toggleFloatingForm() {
        const isExpanded = floatingForm.classList.contains('floating-form--expanded');

        if (isExpanded) {
            floatingForm.classList.remove('floating-form--expanded');
            floatingForm.classList.add('floating-form--minimized');
            floatingFormIcon.classList.remove('fa-times');
            floatingFormIcon.classList.add('fa-arrow-up');
        } else {
            floatingForm.classList.remove('floating-form--minimized');
            floatingForm.classList.add('floating-form--expanded');
            floatingFormIcon.classList.remove('fa-arrow-up');
            floatingFormIcon.classList.add('fa-times');
        }
    }

    floatingFormToggle.addEventListener('click', toggleFloatingForm);
}

export { floatingFormControl };
